export interface MaterialThemeColor {
  "50"?: string | undefined;
  "100": string;
  "200": string;
  "300": string;
  "400": string;
  "500": string;
  "600"?: string | undefined;
  "700"?: string | undefined;
  "800"?: string | undefined;
  "900"?: string | undefined;
  "950"?: string | undefined;
}

export const grey = {
  "50": "#f9f9f9",
  "100": "#f5f5f5",
  "200": "#e0e0e0",
  "300": "#b9b9b9",
  "400": "#969696",
  "500": "#737378",
  "600": "#666666",
  "700": "#525157",
  "800": "#393939",
  "900": "#1f1f1f",
  "950": "#121212",
} as const satisfies MaterialThemeColor;

export const gray = grey satisfies MaterialThemeColor;

export const blue = {
  "50": "#f2f8ff",
  "100": "#e6f0fb",
  "200": "#bfd2e6",
  "300": "#80a5cd",
  "400": "#4079b5",
  "500": "#004c9c",
  "600": "#12437d",
  "700": "#103765",
  "800": "#122c4a",
  "900": "#0a1828",
  "950": "#07111d",
} as const satisfies MaterialThemeColor;

export const primary = blue satisfies MaterialThemeColor;

export const warning = {
  "100": "#ffefdc",
  "200": "#fbcd97",
  "300": "#f8ab51",
  "400": "#d48323",
  "500": "#8e4d00",
} as const satisfies MaterialThemeColor;

export const error = {
  "100": "#ffe2e4",
  "200": "#f79096",
  "300": "#e5414b",
  "400": "#bb2d36",
  "500": "#6b060d",
} as const satisfies MaterialThemeColor;

export const danger = error satisfies MaterialThemeColor;

export const success = {
  "50": "#f0fdf4",
  "100": "#daffdd",
  "200": "#9de5a4",
  "300": "#6bc174",
  "400": "#3c9845",
  "500": "#1d5622",
} as const satisfies MaterialThemeColor;

export const information = {
  "100": "#e2f8ff",
  "200": "#b2e7f9",
  "300": "#8bd5ec",
  "400": "#4490a9",
  "500": "#1f586a",
} as const satisfies MaterialThemeColor;
